import React from 'react';
import {CreditCard, TrendingUp, TrendingDown, CheckCircle, AlertTriangle} from 'lucide-react';
import {CreditInfo} from '../../models/creditInfo.model';
import {CreditInfoMetricCard} from './CreditInfoMetricCard';

interface CreditInfoMetricsGridProps {
  creditInfo: CreditInfo;
  formatCurrency: (amount: number | undefined | null) => string;
  formatPercentage: (percentage: number | undefined | null) => string;
}

export const CreditInfoMetricsGrid: React.FC<CreditInfoMetricsGridProps> = ({
  creditInfo,
  formatCurrency,
  formatPercentage
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* حد الائتمان */}
      <CreditInfoMetricCard
        title="حد الائتمان"
        value={formatCurrency(creditInfo.creditLimit)}
        icon={CreditCard}
        bgColor="bg-gray-50"
        iconColor="text-gray-600"
        textColor="text-gray-700"
        valueColor="text-gray-900"
      />

      {/* إجمالي المبيعات */}
      <CreditInfoMetricCard
        title="إجمالي المبيعات"
        value={formatCurrency(creditInfo.totalSales)}
        icon={TrendingUp}
        bgColor="bg-brand-50"
        iconColor="text-brand-600"
        textColor="text-brand-700"
        valueColor="text-brand-900"
      />

      {/* الائتمان المستخدم */}
      <CreditInfoMetricCard
        title="الائتمان المستخدم"
        value={formatCurrency(creditInfo.usedCredit)}
        icon={TrendingDown}
        bgColor="bg-orange-50"
        iconColor="text-orange-600"
        textColor="text-orange-700"
        valueColor="text-orange-900"
      />

      {/* الائتمان المتبقي */}
      <CreditInfoMetricCard
        title="الائتمان المتبقي"
        value={formatCurrency(creditInfo.remainingCredit)}
        icon={CheckCircle}
        bgColor="bg-green-50"
        iconColor="text-green-600"
        textColor="text-green-700"
        valueColor="text-green-900"
      />

      {/* نسبة استخدام الائتمان */}
      <CreditInfoMetricCard
        title="نسبة الاستخدام"
        value={formatPercentage(creditInfo.creditUsagePercentage)}
        icon={CreditCard}
        bgColor="bg-purple-50"
        iconColor="text-purple-600"
        textColor="text-purple-700"
        valueColor="text-purple-900"
      />

      {/* المبلغ المستحق */}
      <CreditInfoMetricCard
        title="المبلغ المستحق"
        value={formatCurrency(creditInfo.totalDue)}
        icon={AlertTriangle}
        bgColor="bg-red-50"
        iconColor="text-red-600"
        textColor="text-red-700"
        valueColor="text-red-900"
      />
    </div>
  );
};
